<template>

    <Page>
   
        <div class="grid grid-cols-2 justify-center items-center">

            <Video class="scale-150 mt-8"
                src="~/video/protect.mp4" 
                title="Watch Video" 
            />

            <div class="flex flex-col items-center gap-4 pt-12">
            
                <Image src="/protect-logo.png"
                    class="w-3/5 -top-4" 
                />

                <div class="text-center text-sm 2xl:text-base font-semibold uppercase 
                            text-white/80 px-8 -mb-4 lg:-mb-8 -top-4">
                    Revenue Today &middot; More Revenue Tomorrow
                </div>

                <Image
                    src="/images/shared/WhatIsCarbucks/carbucks-protect.png"
                    class="w-[50vw] md:w-full max-w-[420px] mb-6 mx-auto 2xl:-top-4 2xl:-mb-2"
                    floor-shadow
                />

            </div>

        </div>

    </Page>

</template>